import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';


export const SheduledBasicInfoComponent = ({ onInnerBasicFormChange, accountTypesListLoading, accountListLoading, accountTypesList, accountsList, selectedSheduledTasks, PolicyOwnerType, Programs }: any) => {


    return (
        <><AccordionContainer
            child={
                <div className=' grid md:grid-cols-3 lg:grid-cols-3 gap-4'>
                    <InputContainer

                        label="Active"
                        name="IsActive"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event,
                                'IsActive'
                            )
                        }}
                        type="checkbox"
                        value={selectedSheduledTasks?.IsActive}
                    />

                    <InputContainer

                        label="Enable"
                        name="IsEnable"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event,
                                'IsEnable'
                            )
                        }}
                        type="checkbox"
                        value={selectedSheduledTasks?.IsEnable}
                    />

           
                    <InputContainer
                        label="Level"
                        labelField="Text"
                        list={PolicyOwnerType}
                        isDisabled={selectedSheduledTasks?.Id && selectedSheduledTasks?.OwnerLevelId}
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'OwnerLevelId'
                            );
                        }}
                        optionName='Choose Level'
                        type="select"
                        value={selectedSheduledTasks?.OwnerLevelId}
                        valueField="Value"
                    />
                    <InputContainer
                        label="Account Type"
                        labelField="Name"
                        isLoading={accountTypesListLoading}
                        list={accountTypesList}
                        isDisabled={selectedSheduledTasks?.Id && selectedSheduledTasks?.OwnerTypeId}
                        onValueChange={(event: any, newValue: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'OwnerTypeId',
                            );
                        }}
                        optionName='Choose Account Type'
                        type="select"
                        value={selectedSheduledTasks?.OwnerTypeId}
                        valueField="Id"
                    />
                    <InputContainer
                        label="Account Name"
                        labelField="Name"
                        isLoading={accountListLoading}
                        list={accountsList}
                        isDisabled={selectedSheduledTasks?.Id && selectedSheduledTasks?.OwnerAccountId}
                        onValueChange={(event: any, newValue: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'OwnerAccountId',
                            );
                        }}
                        optionName='Choose Account Name'
                        type="select"
                        value={selectedSheduledTasks?.OwnerAccountId}
                        valueField="Id"
                    />

                    <InputContainer
                        label="Name"
                        name="Name"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'Name'

                            )
                        }}
                        type="text"
                        value={selectedSheduledTasks?.Name}
                    />

                    <InputContainer
                        label="Description"
                        name="Description"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'Description'

                            )
                        }}
                        type="text"
                        value={selectedSheduledTasks?.Description}
                    />

                    <InputContainer
                        label="Remarks"
                        name="Remarks"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'Remarks'

                            )
                        }}
                        type="text"
                        value={selectedSheduledTasks?.Remarks}
                    />


                </div>
            }
            expandedPanel="Basic Info"
            headerTitle="Basic Info"
        />
        </>

    )
}
export default SheduledBasicInfoComponent;
